export default function (t) {
  return [
    { title: t('general.code'), field: 'id' },
    { title: t('general.student'), field: 'student.fullName' },
    {
      title: t('mnt_medication.term'),
      field: 'period',
    },
    { title: t('mnt_medication.name'), field: 'name' },
  ];
}
